import { Component, OnInit } from '@angular/core'
import { AuthService } from '../../../../services/auth.services'
import { RestServices } from '../../../../services/rest.services'
import { SharedServices } from '../../../../services/shared.services'
import { ActivatedRoute, ParamMap, Router } from '@angular/router'
import { ordinalSuffixOf } from '../../../../../helper/common'

@Component({
    selector: 'app-mail-history',
    templateUrl: './mail-history.component.html',
    styleUrls: [
        '../../../../stagingcss/main-body.component.css',
        './mail-history.component.css',
        '../../../../stagingcss/lui-select.component.css',
        '../../../top/top.component.css'],
})
export class MailHistoryComponent implements OnInit {
    listClient: any
    listClientMail: any
    hiddenModal = 'hidden'
    en = {}
    showEN = true
    idClient

    constructor(private authData: AuthService, private router: Router, private restApi: RestServices, private _sharedService: SharedServices, private route: ActivatedRoute) {
    }

    ngOnInit() {

        this.route.parent.paramMap.subscribe((params: ParamMap) => {
            const id = params.get('id')
            this.idClient = id
        })

        this.mainClient()
    }

    mainClient() {
        this.callApiMailHistory(this.idClient)
    }

    ordinalSuffixOf(i) {
        if (!i) {
            return ''
        }
        return ordinalSuffixOf(i)
    }

    callApiMailHistory(idClient) {
        const clientId = {}
        var result = '{"clientId":"' + idClient + '"}'
        clientId[result] = true
        const resourceUrl = 'resource'
        const resourceData = {
            actions: [],
            status: {
                clientMail: {
                    paths: clientId,
                },
                clinic: {
                    paths: {
                        '{}': true,
                    },
                },
                setting: {
                    map: {
                        common: true,
                        alignerMail: true,
                    },
                    paths: {
                        '{}': true,
                    },
                },
                staff: {
                    paths: {
                        '{"roles":"cordinator"}': true,
                        '{"roles":"doctor"}': true,
                        '{}': true,
                    },
                },
            },

        }


        this.authData.authToken().then(tokenReNew => {


            this.restApi.http_post(resourceUrl, resourceData, tokenReNew).subscribe(
                success => {
                    const listClientMailData = this.listClientMail = success['response']['clientMail']['paths'][result]
                    listClientMailData.forEach(function(listClientMailItem) {
                        listClientMailItem.modal = 'MailHistory'

                        if (listClientMailItem.type == 'clientDevice' && listClientMailItem.status == 'reserved') {
                            listClientMailItem.type = ''
                        } else {
                            listClientMailItem.type = 'mail-history-type-' + listClientMailItem.type
                        }
                        if (listClientMailItem.status == 'completed') {
                            listClientMailItem.status = 'mail-history-status-completed'
                        } else if (listClientMailItem.status == 'reserved') {
                            listClientMailItem.status = 'mail-history-status-reserved'
                        } else if (listClientMailItem.status == 'canceled') {
                            listClientMailItem.status = 'mail-history-status-canceled'
                        }
                    })
                },
            )
        }).catch(err => {

        })
    }

    changeLanguage() {
        return this.en = this.authData.showLang(this.showEN)
    }

    selectPreview(ClientMailDetail) {
        this._sharedService.emitChange(ClientMailDetail)
    }
}



// WEBPACK FOOTER //
// ./src/app/app_manager/app_element/client-detail/mail-history/mail-history.component.ts